import React from 'react'
import { Icon, Label } from 'semantic-ui-react'
import { Product } from '../../hooks/useProduct'

export const ProductAvailabilityInfo = ({ product }: { product: Product | null }) => {
  const { store_count, states, store_id } = product || {}
  return (
    <>
      <div>
        {store_count === null || store_count === undefined ? (
          <>
            <Icon name="exclamation triangle" />
            Product availability unknown
          </>
        ) : (
          <>
            <Icon name="building" />
            {store_count} store(s)
          </>
        )}
      </div>

      <div>
        <Icon name="globe" style={{ marginTop: '-0.8rem' }} />
        {states?.join(', ') || 'N/A'}
      </div>
      {store_id && (
        <div style={{ marginTop: '10px' }}>
          <Label circular color={'orange'}>
            Store Published
          </Label>
        </div>
      )}
    </>
  )
}
